import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { RemoteData } from 'rf-comp';
import DataTable from 'react-data-table-component';
import generateStatistics from './generateStatistics';
import { fetchAllGameRunners, fetchGroupBalance } from './actions';

const dateFormat = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
};

const customStyles = {
  rows: {
    style: {
      minHeight: '72px', // override the row height
    },
  },
  headCells: {
    style: {
      paddingLeft: '4px', // override the cell padding for head cells
      paddingRight: '4px',
      minWidth: '24px',
    },
  },
  cells: {
    style: {
      paddingLeft: '4px', // override the cell padding for data cells
      paddingRight: '4px',
      minWidth: '24px',
    },
  },
};

const mapCombineStates = (balanceStateInput, gamesStateInput) =>
  gamesStateInput.flatMap(gamesState => balanceStateInput.map(balanceState => ({
    gamesState,
    balanceState
  })));

const GroupStatistics = ({
  games,
  allBalanceState,
  allGameRunnersState,
  players,
  groupId,
  ...props
}) => {
  useEffect(() => {
    props.fetchAllGameRunners();
    props.fetchGroupBalance(groupId);
  }, []);

  const columns = [
    {
      name: 'Navn',
      selector: row => row.name,
      sortable: true,
      minWidth: '20px',
    },
    {
      name: 'Epost',
      selector: row => row.email,
      sortable: true,
      minWidth: '20px',
    },
    {
      name: 'Første spill',
      selector: row => row.firstGame,
      format: (row, index) => row.firstGame ?
        new Date(row.firstGame).toLocaleDateString(dateFormat) :
        '',
      sortable: true,
      minWidth: '20px',
    },
    {
      name: 'Siste spill',
      selector: row => row.lastGame,
      format: (row, index) => row.lastGame ?
        new Date(row.lastGame).toLocaleDateString(dateFormat) :
        '',
      sortable: true,
      minWidth: '20px',
    },
    {
      name: 'Premier',
      selector: row => row.win,
      compact: true,
      sortable: true,
      minWidth: '20px',
    },
    {
      name: 'Mistet lodd',
      selector: row => row.loss,
      sortable: true,
      minWidth: '20px',
    },
    {
      name: 'Saldo',
      selector: row => row.balance,
      sortable: true,
      minWidth: '20px',
    },
    {
      name: 'Totale innskudd',
      selector: row => row.deposited,
      sortable: true,
      minWidth: '20px',
    },
    {
      name: 'Total kjøpsum',
      selector: row => row.spent,
      sortable: true,
      minWidth: '20px',
    },
    {
      id: 'pricePerWin',
      name: 'Pris per premie',
      selector: row => row.pricePerWin,
      sortable: true,
      minWidth: '20px',
    },
  ];

  return (
    <RemoteData type={mapCombineStates(allBalanceState, allGameRunnersState)}
                  loading={() => <span>Henter...</span>}
                  failure={err => <span>Feil under henting: {err.message}</span>}
                  success={({
                    balanceState,
                    gamesState
                  }) => {
                    const stats = generateStatistics(players, games, balanceState, gamesState);
                    return (
                      <DataTable
                        columns={columns}
                        data={stats}
                        customStyles={customStyles}
                        defaultSortFieldId="pricePerWin"
                        defaultSortAsc
                        dense
                      />
                    );
                  }}
      />
  );
};

GroupStatistics.propTypes = {
  groupId: PropTypes.string.isRequired,
  games: PropTypes.array.isRequired,
  players: PropTypes.array.isRequired,
  allBalanceState: PropTypes.object.isRequired,
  allGameRunnersState: PropTypes.object.isRequired,
  fetchGroupBalance: PropTypes.func.isRequired,
  fetchAllGameRunners: PropTypes.func.isRequired,
};

const mapStateToProps = ({
  statisticsPageForGroup
}) => ({
  allBalanceState: statisticsPageForGroup.allBalanceState,
  allGameRunnersState: statisticsPageForGroup.allGameRunnersState
});

const mapDispatchToProps = dispatch => ({
  fetchGroupBalance: fetchGroupBalance(dispatch),
  fetchAllGameRunners: fetchAllGameRunners(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(GroupStatistics);
